
import TopCategoryTile from "./TopCategoryTile";

export default {
  components: { TopCategoryTile },

  props: { fields: { type: Array, default: () => {} } },

  data: () => ({ swiper: null }),

  computed: {
    swiperOptions() {
      return {
        slidesPerView: "auto",
        spaceBetween: 16,
        slidesPerGroup: 1,
        loop: false,
      };
    },
  },

  async mounted() {
    await this.$swiper.init(".swiper.m-top-category", this.swiperOptions);
  },
  destroyed() {
    this.swiper?.destroy?.();
  },
};
